import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import { alignItems, crossPageNotifications, routePaths, strCode } from "../../consts";
import { navigationService, t } from "../../services";
import { notificationUtils } from "../../utils";
import { withSection } from "../../hoc";
import { useFetchNotifications, useUpdateNotification } from "../../apiHooks";

import {
  Breadcrumbs,
  FlexContainers,
  Heading5,
  PageContainer,
  Paragraph2,
  WrapperContainer
} from "../../components";
import { NewNotificationForm } from "../../containers";

const EditNotificationPage = () => {
  const { notificationName } = useParams();
  const [notificationToEdit, setNotificationToEdit] = useState(null);

  const isSystemNotification = useMemo(() => {
    return notificationToEdit && notificationToEdit?.isSystemNotification;
  }, [notificationToEdit]);

  const {
    data: { notifications, systemNotifications },
    fetchCallback: fetchNotifications,
    loading
  } = useFetchNotifications();
  const { mutationCallback: updateNotification } = useUpdateNotification();

  const handleUpdateNotification = useCallback(
    async (notification, binaryImage, { isSameData, isSystemNotification }) => {
      await updateNotification(notification, binaryImage, { isSameData, isSystemNotification });

      if (window.opener) {
        // notify parent page about completed change
        const notification = {
          type: crossPageNotifications.notificationMessageUpdate,
          payload: notificationName
        };

        window.opener.postMessage(notification);
      }
    },
    [updateNotification]
  );

  const availableSystemNotificationOptions = useMemo(() => {
    return notificationUtils.getAvailableSystemNotificationOptions();
  }, []);

  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    if (notifications && systemNotifications && !loading) {
      const notificationList = [...notifications, ...systemNotifications];
      const notification = notificationList.find((x) => x.notificationName === notificationName);

      if (notification) {
        setNotificationToEdit(notification);
      } else {
        navigationService.redirect(routePaths.NOTIFICATIONS);
      }
    }
  }, [notificationName, notifications, systemNotifications, loading]);

  return (
    <PageContainer alignItems={alignItems.start}>
      <WrapperContainer
        Container={FlexContainers.FlexColumnStart}
        alignItems={alignItems.start}
        width="100%"
        height="100%">
        <Breadcrumbs />
        <Heading5>{t(strCode.EDIT_NOTIFICATION_TITLE)}</Heading5>
        {loading ? (
          <WrapperContainer
            Container={FlexContainers.FlexColumnCenter}
            width={"100%"}
            mt={200}
            textAlign={"center"}>
            <Paragraph2>{t(strCode.LOADING)}</Paragraph2>
          </WrapperContainer>
        ) : (
          <NewNotificationForm
            notificationsData={notificationToEdit}
            isSystemNotification={isSystemNotification}
            availableSystemNotificationOptions={availableSystemNotificationOptions}
            onSaveNotification={handleUpdateNotification}
          />
        )}
      </WrapperContainer>
    </PageContainer>
  );
};

export default withSection(EditNotificationPage);
